export const RECEIPT_SAVED_EVENT = 'receipt-saved'
export const RECEIPT_HEADER_ID = 'receipt-header-warning'
